import { loadStripe } from "@stripe/stripe-js";
import { supabase } from "./supabase";

let stripePromise: Promise<any>;

export const getStripe = () => {
  if (!stripePromise) {
    const key = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
    if (!key) {
      throw new Error("Missing Stripe public key");
    }
    stripePromise = loadStripe(key);
  }
  return stripePromise;
};

export const startPremiumCheckout = async (
  email: string,
  archetype: string,
  reportId: string = ""
) => {
  try {
    if (!email) {
      throw new Error("Email is required for checkout");
    }

    let validURL = "create-checkout-session-es";
    if (import.meta.env.VITE_ENVIRONMENT === "development") {
      validURL = "create-checkout-session-test";
    }

    // Create checkout session via Edge Function
    const { data, error } = await supabase.functions.invoke(validURL, {
      body: {
        email,
        archetype,
        reportId,
      },
    });

    if (error) {
      console.error("Edge function error:", error);
      throw new Error("Failed to create checkout session");
    }

    if (!data?.sessionId) {
      throw new Error("No session ID returned from checkout creation");
    }
    console.log("Checkout session created:", data.sessionId);
    // Initialize Stripe
    const stripe = await getStripe();
    if (!stripe) {
      throw new Error("Failed to initialize Stripe");
    }

    console.log("Stripe initialized successfully");
    // Redirect to checkout
    const result = await stripe.redirectToCheckout({
      sessionId: data.sessionId,
    });

    console.log("Stripe redirect result:", result);
    if (result.error) {
      throw new Error(result.error.message);
    }
  } catch (error) {
    console.error("Checkout error:", error);
    throw error;
  }
};
